import React, { useContext } from "react";
import { ViewContext } from "venuescanner-js/react/components/Inbox/context/ViewContext";
import AutomatedMessageText from "../../AutomatedMessageText";

const AutomatedMessageBookedEnquiry = ({ thread, children }) => {
  const { isMobileDevice } = useContext(ViewContext);

  return (
    <AutomatedMessageText
      tagTitle="Booked"
      tagClass={isMobileDevice ? ["automated-message-tag--booked-mobile"] : []}
    >
      {children}
    </AutomatedMessageText>
  );
};

export default AutomatedMessageBookedEnquiry;
